// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".completed {\n  text-decoration: line-through;\n}", "",{"version":3,"sources":["webpack://./src/app/taskboard/components/child-tasks/child-tasks.component.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;AACF","sourcesContent":[".completed {\r\n  text-decoration: line-through;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
